import {Box, Typography} from '@mui/material';
import PortGdyLogo from '../../assets/port-gdynia-symbol-white.png';
import {PORT_GDYNIA_MAIN_COLOR} from '../../utils';
import {useState} from 'react';
import DeviceInfoPopup from '../DevicePopup/DeviceInfoPopup';

const size = 30;

export default function DeviceMarker({timestamp, pm10, pm25, noise, left, top, onClick, label, marginTop, marginLeft, labelTop, labelLeft}) {
  const [showPopup, setShowPopup] = useState(false);

  return <Box width={size} height={size}
              onMouseOver={() => setShowPopup(true)}
              onMouseOut={() => setShowPopup(false)}
              sx={{
                backgroundColor: PORT_GDYNIA_MAIN_COLOR,
                backgroundImage: `url(${PortGdyLogo})`,
                position: 'absolute',
                cursor: 'pointer',
                left,
                top,
                borderRadius: size,
                padding: .3
              }}
              onClick={onClick}>
    {showPopup && <Box >
      <DeviceInfoPopup
        name={label}
        left={labelLeft}
        top={labelTop}
        pm10={pm10}
        pm25={pm25}
        noise={noise}
        date={new Date(timestamp)}
      />
    </Box>}
    <img width={size} height={size} src={PortGdyLogo}/>
    <Box sx={{marginLeft: marginLeft, marginTop: marginTop}} width={200}>
      {label && <Typography color={PORT_GDYNIA_MAIN_COLOR} variant={'button'} fontWeight={'bold'}>{label}</Typography>}
    </Box>

  </Box>;
}
